import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const THEMES = ['field-blue', 'field-blue-light', 'aurora', 'sunlight', 'night', 'underground', 'teal', 'office'];

export function createThemeStore(storageKey) {
  return create(
    persist(
      (set) => ({
        theme: 'field-blue',
        setTheme: (theme) => {
          if (!THEMES.includes(theme)) return;
          document.documentElement.setAttribute('data-theme', theme);
          set({ theme });
        },
      }),
      {
        name: storageKey,
        onRehydrateStorage: () => (state) => {
          if (THEMES.includes(state?.theme)) {
            document.documentElement.setAttribute('data-theme', state.theme);
          }
        },
      }
    )
  );
}

export { THEMES };
